import { useStore } from 'hooks/useStore';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

export const useBulkUpdate = (
  directData?: {
    Concept: string;
    NDC11_list: {
      NDC11: string;
    }[];
  }[],
  indirectData?: {
    Concept: string;
    NDC11_list: {
      NDC11: string;
    }[];
  }[]
) => {
  const {
    UnconstrainedForecastViewStore: {
      bulkUpdateDirectTodoNDC,
      bulkUpdateDirectCompletedNDC,
      bulkUpdateIndirectTodoNDC,
      bulkUpdateIndirectCompletedNDC,
      isForecastBulkUpdating,
      bulkUpdateUnconstrainedForecast,
    },
  } = useStore();

  const [directConceptname, setDirectconceptname] = useState<string>('');
  const [indirectConceptname, setIndirectconceptname] = useState<string>('');
  const [directfilteredData, setDirectfilteredData] = useState(directData);
  const [indirectfilteredData, setIndirectfilteredData] = useState(indirectData);
  const [isDirectBulkUpdating, setIsDirectBulkUpdating] = useState<boolean>(false);
  const [isIndirectBulkUpdating, setIsIndirectBulkUpdating] = useState<boolean>(false);
  const [isBulkUpdating, setIsBulkUpdating] = useState<boolean>(false);

  useEffect(() => {
    // Update filtered data whenever the original data or search term changes
    if (directData && directData.length > 0) {
      setDirectfilteredData(
        directData?.filter(item =>
          item?.Concept?.toLowerCase()?.includes(directConceptname.toLowerCase())
        )
      );
    }

    if (indirectData && indirectData.length > 0) {
      setIndirectfilteredData(
        indirectData?.filter(item =>
          item?.Concept?.toLowerCase()?.includes(indirectConceptname.toLowerCase())
        )
      );
    }
  }, [directData, indirectData, directConceptname, indirectConceptname]);

  const handleDirectSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    setDirectconceptname(e.target.value);
  };

  const handleIndirectSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    setIndirectconceptname(e.target.value);
  };

  const handleDirectBulkUpdate = async () => {
    try {
      setIsDirectBulkUpdating(true);
      await bulkUpdateUnconstrainedForecast('direct');
      toast.success('Bulk Update Successful');
    } catch (error) {
      console.log('Error while bulk updating=> ', error);
      toast.error('Unable to Bulk Update');
    } finally {
      setIsDirectBulkUpdating(false);
    }
  };

  const handleIndirectBulkUpdate = async () => {
    try {
      setIsIndirectBulkUpdating(true);
      await bulkUpdateUnconstrainedForecast('indirect');
      toast.success('Bulk Update Successful');
    } catch (error) {
      console.log('Error while bulk updating=> ', error);
      toast.error('Unable to Bulk Update');
    } finally {
      setIsIndirectBulkUpdating(false);
    }
  };

  const handleBulkUpdate = async () => {
    try {
      setIsBulkUpdating(true);
      await bulkUpdateUnconstrainedForecast('all');
      toast.success('Bulk Update Successful');
    } catch (error) {
      console.log('Error while bulk updating=> ', error);
      toast.error('Unable to Bulk Update');
    } finally {
      setIsBulkUpdating(false);
    }
  };

  return {
    bulkUpdateDirectTodoNDC,
    bulkUpdateDirectCompletedNDC,
    bulkUpdateIndirectTodoNDC,
    bulkUpdateIndirectCompletedNDC,
    isForecastBulkUpdating,
    directConceptname,
    indirectConceptname,
    directfilteredData,
    indirectfilteredData,
    isDirectBulkUpdating,
    isIndirectBulkUpdating,
    isBulkUpdating,
    setDirectconceptname,
    setIndirectconceptname,
    setDirectfilteredData,
    handleDirectSearchChange,
    handleIndirectSearchChange,
    setIndirectfilteredData,
    handleDirectBulkUpdate,
    handleIndirectBulkUpdate,
    handleBulkUpdate,
  };
};
